import { memo, VFC, useEffect, useState } from 'react';
import {
  Modal,ModalOverlay,ModalContent,ModalFooter,ModalBody,ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';
// import { useLoginUser } from '../../../hooks/providers/useLoginUserProvider';
import { useNavigate } from "react-router-dom";
import { IssueGroupDetailBase } from '../base/IssueGroupDetailBase';
import { PrimaryButton } from '../../atoms/button/PrimaryButton';
import { useIssue } from '../../../hooks/useIssue';
import { ErrorDialog } from '../../organisms/modal/ErrorDialog';
import { IssueDetailDialog } from '../../organisms/modal/IssueDetailDialog';
import { useOpelog } from '../../../hooks/useOpelog';
import { GV_DIALOG_SIZE } from '../../../hooks/useConst';

type Props = {
  groupName: string;
  setGroupName: (group:string)=>void;
  groupIssueArn?: string;
  direct? : boolean;
};

export const IssueGroupDetailDialog: VFC<Props> = memo((props) => {
  const { groupName, setGroupName, groupIssueArn='', direct=false } = props;
  const navigate = useNavigate();
  // const { loginUser } = useLoginUser();
  const [ title ] = useState('障害グループまとめ');
  const { OutputOpelog } = useOpelog();
  const { getIssueGroupResult, executing, errObj, getIssueGroup } = useIssue();
  const [ issueArn, setIssueArn ] = useState("");
  const { isOpen, onOpen } = useDisclosure();
  const [ closeFlag, setCloseFlag ] = useState(false);
  const [ execFlag, setExecFlag ] = useState(false);
  
  useEffect(() => {
    !isOpen && onOpen();
    setExecFlag(true);
    // eslint-disable-next-line
  }, []);
  
  useEffect(() => {
    if( (groupName || getIssueGroup) && execFlag ){
      setExecFlag(false);
      getIssueGroup(groupName,groupIssueArn) ;
      
      OutputOpelog('issue_summary', 'reference', "GROUP_NAME#" + groupName);
    }
  }, [groupName,execFlag,getIssueGroup]);
  
  // groupIssueArnで検索した場合、一応groupNameを設定
  useEffect(() => {
    if( groupName === '' && getIssueGroupResult ){
      setGroupName(getIssueGroupResult.group_name_org);
    }
  }, [getIssueGroupResult]);
  
  // エラーダイアログクローズ時は、ダイアログ表示できないので障害グループに遷移
  useEffect(() => {
    if( closeFlag ) navigate(`/historyView`);
  }, [closeFlag]);
  
  return (
    <>
    {errObj && !closeFlag ? (
      <ErrorDialog errTitle={title} errObj={errObj} opeErrMes="" setCloseFlag={setCloseFlag} />
    
    ) : (direct && issueArn === '') ? (
      <IssueGroupDetailBase
        getIssueGroupResult={getIssueGroupResult}
        executing={executing}
        setIssueArn={setIssueArn}
        setExecFlag={setExecFlag} 
      />
      
    ) : issueArn !== '' ? (
      <IssueDetailDialog issueArn={issueArn} setIssueArn={setIssueArn} />
    
    ) : (
      <>
      <Modal
        isOpen={isOpen}
        onClose={()=>setGroupName('')}
        motionPreset="slideInBottom"
        autoFocus={false}
        size={GV_DIALOG_SIZE}
        isCentered
        closeOnOverlayClick={false}
        scrollBehavior='inside'
        allowPinchZoom
        >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <IssueGroupDetailBase getIssueGroupResult={getIssueGroupResult} executing={executing} setIssueArn={setIssueArn} setExecFlag={setExecFlag} />
          </ModalBody>
          
          <ModalFooter>
            <PrimaryButton type='ok' onClick={()=>setGroupName('')} isLoading={executing}>
              閉じる
            </PrimaryButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      </>
    )}
    </>
  );
});